export default [
    {
        "serverEnumName": "Bower",
        "value": "bower",
        "text": "Bower",
        "icon": 'bower'
    },
    {
        "serverEnumName": "CocoaPods",
        "value": "cocoapods",
        "text": "CocoaPods",
        "icon": 'cocoapods'
    },
    {
        "serverEnumName": "Debian",
        "value": "debian",
        "text": "Debian",
        "icon": 'deb'
    },
    {
        "serverEnumName": "Docker",
        "value": "docker",
        "text": "Docker",
        "icon": 'docker'
    },
    {
        "serverEnumName": "Gems",
        "value": "gems",
        "text": "Gems",
        "icon": 'ruby-gems'
    },
    {
        "serverEnumName": "GitLfs",
        "value": "gitlfs",
        "text": "Git LFS",
        "icon": 'git-lfs'
    },
    {
        "serverEnumName": "Gradle",
        "value": "gradle",
        "text": "Gradle",
        "icon": 'gradle'
    },
    {
        "serverEnumName": "Ivy",
        "value": "ivy",
        "text": "Ivy",
        "icon": 'ivy'
    },
    {
        "serverEnumName": "Maven",
        "value": "maven",
        "text": "Maven",
        "icon": 'pom'
    },
    {
        "serverEnumName": "Npm",
        "value": "npm",
        "text": "npm",
        "icon": 'npm'
    },
    {
        "serverEnumName": "NuGet",
        "value": "nuget",
        "text": "NuGet",
        "icon": 'nuget'
    },
    {
        "serverEnumName": "Opkg",
        "value": "opkg",
        "text": "Opkg",
        "icon": 'opkg'
    },
    {
        "serverEnumName": "P2",
        "value": "p2",
        "text": "P2",
        "icon": 'p2'
    },
    {
        "serverEnumName": "Pypi",
        "value": "pypi",
        "text": "PyPI",
        "icon": 'pypi'
    },
    {
        "serverEnumName": "SBT",
        "value": "sbt",
        "text": "SBT",
        "icon": 'sbt'
    },
    {
        "serverEnumName": "Vagrant",
        "value": "vagrant",
        "text": "Vagrant",
        "icon": 'vagrant'
    },
    {
        "serverEnumName": "VCS",
        "value": "vcs",
        "text": "VCS",
        "icon": 'vcs'
    },
    {
        "serverEnumName": "Yum",
        "value": "yum",
        "text": "YUM",
        "icon": 'yum'
    },
    {
        "serverEnumName": "Generic",
        "value": "generic",
        "text": "Generic",
        "icon": 'generic'
    }
]



// WEBPACK FOOTER //
// ./modules/xray/constants/package_types.js